/* =====================================================================
   ENTROPICA CORE ENGINE (GLOBAL SCOPE)
   ===================================================================== */

document.addEventListener("DOMContentLoaded", function() {

  /* --- 1. MASTER CART DRAWER OVERRIDE (GLOBAL CAPTURE) --- */
  if (!window.entropicaMasterCartBound) {
    document.addEventListener('click', function(e) {
      const cartBubble = e.target.closest('#cart-icon-bubble, .header__icon--cart, a[href^="/cart"]');
      if (cartBubble) {
        // Prevent default navigation to the /cart page
        e.preventDefault(); 
        e.stopImmediatePropagation(); 
        
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          if (typeof cartDrawer.open === 'function') {
            cartDrawer.open(cartBubble);
          } else {
            cartDrawer.classList.add('is-active', 'active', 'animate');
            document.body.classList.add('overflow-hidden');
          }
        }
      }
    }, true); // Use capture phase to intercept before native theme JS
    window.entropicaMasterCartBound = true;
  }

  /* --- 2. UNIVERSAL AJAX CART ENGINE --- */
  // This will bind to any form with the class 'entropica-ajax-form'
  document.addEventListener('submit', function(e) {
    const form = e.target.closest('.entropica-ajax-form');
    if (!form) return;

    e.preventDefault(); 
    const submitBtn = form.querySelector('button[type="submit"]');
    if (!submitBtn) return;
    
    const originalText = submitBtn.innerText;
    submitBtn.innerText = 'Processing...';
    submitBtn.disabled = true;

    const formData = new FormData(form);
    formData.append('sections', 'cart-drawer,cart-icon-bubble');
    formData.append('sections_url', window.location.pathname);

    const fetchUrl = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js';

    fetch(fetchUrl, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' }, 
      body: formData
    })
    .then(res => { if (!res.ok) throw new Error('Network response error'); return res.json(); })
    .then(data => {
      // Logic for pre-order text swap
      const isPreorder = submitBtn.dataset.preorder === "true";
      submitBtn.innerText = isPreorder ? 'Pre-Order Secured' : 'Secured';
      
      // Inject updated Dawn sections
      if (data.sections) {
        if (data.sections['cart-drawer']) {
          const parsedDrawer = new DOMParser().parseFromString(data.sections['cart-drawer'], 'text/html');
          const currentDrawer = document.querySelector('cart-drawer');
          const newDrawer = parsedDrawer.querySelector('cart-drawer');
          if (currentDrawer && newDrawer) {
            currentDrawer.innerHTML = newDrawer.innerHTML;
            currentDrawer.className = newDrawer.className; 
          }
        }
        if (data.sections['cart-icon-bubble']) {
          const parsedBubble = new DOMParser().parseFromString(data.sections['cart-icon-bubble'], 'text/html');
          const currentBubble = document.querySelector('#cart-icon-bubble');
          const newBubble = parsedBubble.querySelector('#cart-icon-bubble');
          if (currentBubble && newBubble) currentBubble.innerHTML = newBubble.innerHTML;
        }
      }

      // Trigger the drawer
      const drawerElement = document.querySelector('cart-drawer');
      if (drawerElement) {
         if (typeof drawerElement.open === 'function') drawerElement.open(); 
         else { drawerElement.classList.add('active'); document.body.classList.add('overflow-hidden'); }
      } else {
         document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
      }

      setTimeout(() => { submitBtn.innerText = originalText; submitBtn.disabled = false; }, 2000);
    })
    .catch(error => {
      console.error('Entropica Cart Error:', error);
      submitBtn.innerText = 'System Error.';
      setTimeout(() => { submitBtn.innerText = originalText; submitBtn.disabled = false; }, 3000);
    });
  });

  /* --- 3. SCROLL REVEAL ENGINE (fade-in-content / staggered-item / titanium-sweep) --- */
  if ('IntersectionObserver' in window) {
    const revealTargets = document.querySelectorAll('.fade-in-content, .staggered-item, .titanium-sweep');

    if (revealTargets.length) {
      const revealObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -10% 0px' });

      revealTargets.forEach((target) => revealObserver.observe(target));
    }
  } else {
    // Fallback: no IntersectionObserver support, reveal everything immediately
    document.querySelectorAll('.fade-in-content, .staggered-item, .titanium-sweep').forEach((target) => {
      target.classList.add('is-visible');
    });
  }

});
/* ── THE FORCEFIELD (VAPORIZE) ENGINE ──────────────────────────────────────
 *
 * Masks a section's top edge as it slides under the fixed header, so content
 * dissolves into the header line instead of colliding with it.
 *
 * WHY THIS LIVES HERE AND NOT IN A SECTION. It was copy-pasted into 14
 * sections and drifted: featherZone was 40 in argon-selection, 60 in
 * The-curators-ledger, 45 in six others, and a viewport-relative value in the
 * product sections. Five more sections (entropica-cart, entropica-index,
 * entropica-related, entropist-hub, index-referral-prompt) marked elements
 * `.vaporize-target` but shipped no handler at all, so the class did nothing
 * unless another section on the same page happened to supply one. The policy
 * and FAQ pages had neither. The grain and the reveal observer were promoted
 * to global assets already; this was the one piece of chrome left behind.
 *
 * The viewport-relative featherZone is kept — it is the newest variant and the
 * only one that scales with window height.
 *
 * Idempotent: safe while legacy per-section handlers still exist, and re-scans
 * on Shopify section render so the theme editor stays correct.
 */
(function () {
  if (window.__entropicaVaporize) return;
  window.__entropicaVaporize = true;

  var HEADER_LINE = 90;
  var isMobile = window.matchMedia('(max-width: 768px)');
  var targets = [];
  var ticking = false;

  function clear(el) {
    el.style.webkitMaskImage = '';
    el.style.maskImage = '';
  }

  /* Pages built from Entropica sections mark their own targets. Pages Shopify
     renders itself — every /policies/* page, 404, search, cart, the customer
     account views — have no section to mark anything, so they got a fixed
     TRANSPARENT header with nothing masking the content sliding under it, and
     body copy collided with the logo and the cart icon mid-scroll. Confirmed
     on /policies/privacy-policy 2026-09-01.

     layout/theme.liquid:394 wraps every page's content in
     <main id="MainContent">, so that is the one element guaranteed to exist.
     Fall back to it ONLY when a page marks no targets of its own: curated
     pages keep their existing per-element behaviour untouched, and everything
     else gets covered automatically instead of one section at a time. */
  function scan() {
    targets = Array.prototype.slice.call(document.querySelectorAll('.vaporize-target'));
    if (!targets.length) {
      var main = document.getElementById('MainContent');
      if (main) targets = [main];
    }
  }

  function apply() {
    if (isMobile.matches) {
      targets.forEach(clear);
      return;
    }
    /* Ease the mask in over the first `fullFeather` px of scroll.

       At rest nothing has passed under the header yet, so masking here fades the
       page's own heading. The fallback target is #MainContent, whose rect.top is 0
       on a page scrolled to the top — indistinguishable, to the old code, from
       content that has genuinely slid under the header. Measured on
       /policies/privacy-policy at scrollY 0: clip 90 against a 331px feather gave
       `linear-gradient(transparent 90px, black 420.5px)`, rendering the
       "Privacy policy" h1 (viewport y 100) at 3-19% opacity. Same on
       /pages/the-index and /collections/coffee-gear. Confirmed 2026-09-03.

       Scroll distance is the honest measure of how much content has passed under
       the header, so the feather scales with it. At scrollY 0 the effect is off
       entirely; by the time it is fully on, the transparent boundary has moved
       down in lockstep, so the faded band is always the `feather` px directly
       below HEADER_LINE and there is no pop on the first scroll event. The
       mid-scroll dissolve is unchanged. */
    var fullFeather = window.innerHeight * 0.25;
    if (fullFeather <= 0) {
      targets.forEach(clear);
      return;
    }
    var progress = Math.min(1, Math.max(0, window.scrollY) / fullFeather);
    if (progress <= 0) {
      targets.forEach(clear);
      return;
    }
    var feather = fullFeather * progress;
    targets.forEach(function (el) {
      var rect = el.getBoundingClientRect();
      if (rect.top < HEADER_LINE + feather && rect.bottom > 0) {
        var clip = HEADER_LINE - rect.top;
        var g = 'linear-gradient(to bottom, transparent ' + clip + 'px, black ' + (clip + feather) + 'px)';
        el.style.webkitMaskImage = g;
        el.style.maskImage = g;
      } else if (el.style.maskImage) {
        clear(el);
      }
    });
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      apply();
      ticking = false;
    });
  }

  function init() {
    scan();
    apply();
  }

  document.addEventListener('DOMContentLoaded', init);
  if (document.readyState !== 'loading') init();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  document.addEventListener('shopify:section:load', function () { scan(); apply(); });
})();

/* ── SCROLL-LOCK FAILSAFE ──────────────────────────────────────────────────
 *
 * The intro gates pin the whole document while the loader plays:
 *
 *   .entropica-scroll-lock, .entropica-scroll-lock body {
 *     overflow: hidden !important; height: 100vh !important; }
 *
 * The class goes on <html> at DOMContentLoaded (homepage-test.liquid:695,
 * argon-selection.liquid:604) and is removed from the bottom of a chain of
 * three nested setTimeouts — 1500ms then 1000ms then 2000ms, ~4.5s total
 * (homepage-test.liquid:764, argon-selection.liquid:658). That chain has no
 * failure path. If anything before the innermost timer throws, the timer is
 * never scheduled, the class is never removed, and the document stays pinned
 * to exactly one viewport with scrolling disabled — which is why the footer
 * only appeared in fullscreen, where 100vh is ~90-140px taller and more of
 * the page fits inside the lock.
 *
 * Two other sections make it worse: in-stock-roasters.liquid and
 * page-summit-bid.liquid ship the same lock CSS but contain no code that adds
 * OR removes the class, so a lock inherited on those pages has nothing local
 * that can lift it.
 *
 * The release below is unconditional and lives outside every animation chain.
 * The delay sits deliberately above the ~4.5s intended release so the intro is
 * untouched in the happy path — this only ever fires when the gate failed. It
 * removes and never adds, so it cannot itself cause a lock.
 */
(function () {
  if (window.__entropicaScrollLockFailsafe) return;
  window.__entropicaScrollLockFailsafe = true;

  var LOCK_CLASSES = ['entropica-scroll-lock', 'argon-scroll-lock'];
  var HARD_RELEASE_MS = 7000;

  function release() {
    var h = document.documentElement;
    var stuck = LOCK_CLASSES.filter(function (c) { return h.classList.contains(c); });
    if (!stuck.length) return;
    stuck.forEach(function (c) { h.classList.remove(c); });
    if (window.console && console.warn) {
      console.warn('[entropica] scroll lock released by failsafe: ' + stuck.join(', ') +
        ' — the intro gate did not lift it.');
    }
  }

  setTimeout(release, HARD_RELEASE_MS);
  window.addEventListener('load', function () { setTimeout(release, HARD_RELEASE_MS); });
})();
